import React, { FC, SyntheticEvent, useEffect, useState } from 'react';
import clsx from 'clsx';
import { DivImageWrapper, DivWrapper, DivPrevNext, DivLabel, ImgPreview, ButtonClose } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronRight, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { FnLoader } from '../../components/elements/FnLoader';

type TProps = {
  images: string[];
  labels?: string[];
  onClose: () => void;
};

const ImageReview: FC<TProps> = ({ images, labels, onClose }) => {
  const START_INDEX = 0;
  const [current, setCurrent] = useState(START_INDEX);
  const [image, setImage] = useState(images[START_INDEX]);
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});
  const total = images.length;

  const goNext = () => {
    if (current >= total) return;
    setCurrent(current + 1);
  };

  const goPrev = () => {
    if (current == 0) return;
    setCurrent(current - 1);
  };

  const loaded = (image) => {
    setLoadedImages({ ...loadedImages, [image]: true });
  };

  useEffect(() => {
    setNext(current + 1 < total);
    setPrev(current > 0);
    setImage(images[current]);
  }, [current]);

  return (
    <DivWrapper onClick={onClose}>
      <DivImageWrapper onClick={(event: SyntheticEvent) => event.stopPropagation()}>
        <ButtonClose type="button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </ButtonClose>
        {prev && (
          <DivPrevNext
            isPrev={true}
            onClick={(event: SyntheticEvent) => {
              event.stopPropagation();
              goPrev();
            }}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </DivPrevNext>
        )}
        {next && (
          <DivPrevNext
            onClick={(event: SyntheticEvent) => {
              event.stopPropagation();
              goNext();
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </DivPrevNext>
        )}

        {!loadedImages[image] && <FnLoader />}

        {images.map((i) => (
          <ImgPreview src={i}
                      key={i}
                      alt={i}
                      onLoad={() => loaded(i)}
                      onError={() => loaded(i)}
                      className={clsx({ 'd-none': i !== image })}
          />
        ))}

        {labels?.[current] && <DivLabel>{labels?.[current]}</DivLabel>}
      </DivImageWrapper>
    </DivWrapper>
  );
};

export default ImageReview;
